import { createTheme } from "@mui/material/styles";

// ---- Core palette (from Login.js) ----
export const NAVY = "#0B2545";
export const SLATE = "#134074";
export const PANEL_BLUE_START = "#1B4F8C";
export const PANEL_BLUE_END = "#2E86C1";
export const GOLD = "#C89B3C";
export const BG = "#F7F9FB";

const theme = createTheme({
  palette: {
    primary: {
      main: NAVY,
      light: SLATE,
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: SLATE,
      contrastText: "#FFFFFF",
    },
    background: {
      default: BG,
      paper: "#FFFFFF",
    },
    // Custom token — not a standard MUI palette key, but usable via theme.palette.gold.main
    gold: {
      main: GOLD,
      contrastText: "#111111",
    },
    success: { main: "#1D9E75" },
    error: { main: "#D14343" },
    text: {
      primary: NAVY,
      secondary: "#555555",
    },
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', Roboto, sans-serif",
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    // Global input styling to match Login.js fields
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          "&.Mui-focused fieldset": {
            borderColor: SLATE,
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: SLATE,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 10,
          boxShadow: "none",
        },
        containedPrimary: {
          backgroundColor: NAVY,
          "&:hover": {
            backgroundColor: SLATE,
            boxShadow: "none",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 10px 30px rgba(4, 16, 33, 0.10)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: NAVY,
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: NAVY,
          color: "#FFFFFF",
        },
      },
    },
  },
});

export default theme;